import utils from "../../../src/js/utils";

function charmatSlider() {
	var sliders = document.querySelectorAll(".atk-merotto-charmat");

	if (sliders.length > 0) {
		utils.forEach(sliders, function (index, slider) {
			var elem = slider.querySelector(".splide");

			var splide = new Splide(elem, {
				type: "slide",
				perPage: 3,
				gap: "3rem",
				perMove: 1,
				arrows: true,
				speed: 2000,
				pagination: false,
				drag: true,
				focus: 0,
				omitEnd: true,
				arrowPath:
					"m20,36.81l13-18.4L20,0l20,18.4-20,18.4Zm-7-18.4L0,36.81l20-18.4L0,0l13,18.4Z",
				classes: {
					// Add classes for arrows.
					arrows: "atk-navigation",
					arrow: "atk-nav",
					prev: "prev carousel-prev",
					next: "next carousel-next",
					pagination: "atk-pagination",
					page: "atk-dot",
				},
				breakpoints: {
					576: {
						perPage: 2,
						gap: "1.7rem",
					},
					786: {
						perPage: 2,
						gap: "2.3rem",
						drag: false,
					},
				},
			});

			var progressBar = slider.querySelector(".inner-progress");

			splide.on("move", function () {
				var end = splide.Components.Controller.getEnd();
				var progress = Math.min(splide.index / end, 1);

				progressBar.style.transform = "scale(" + progress + ", 1)";
			});

			splide.mount();
		});
	}
}

utils.domReady(function () {
	charmatSlider();
});
